<script setup>
import vueRecaptcha from "vue3-recaptcha2";
import { usePage } from "@inertiajs/vue3";
import { ref, computed, onMounted, nextTick, watch } from "vue";
const emit = defineEmits(["verified"]);
const page = usePage();
const { reset } = defineProps({
  reset: {
    type: Boolean,
    default: false,
  },
});
const locale = computed(() => {
  return page.props.locale;
});
const sitekey = computed(() => {
  return page.props.setting.recaptcha_site_key;
});
const isEnable = computed(() => {
  return page.props.setting.recaptcha_enable;
});

const emitVerify = (response) => {
  emit("verified", response);
};
const recaptcha = ref(null);

const onExperid = () => {
  if (isEnable.value) {
    // when you need a reCAPTCHA challenge
    recaptcha.value.reset();
  }
};
watch(
  () => reset,
  (value) => {
    if (value) {
      nextTick(() => {
        onExperid();
      });
    }
  }
);

// Add a watcher for form errors to reset the reCAPTCHA
watch(
  () => page.props.errors,
  (errors) => {
    if (
      errors["g-recaptcha-response"] ||
      errors["recaptcha"] ||
      errors["email"] ||
      errors["password"]
    ) {
      nextTick(() => {
        onExperid();
      });
    }
  }
);
</script>

<template>
  <template v-if="isEnable != false && isEnable != 'false' && sitekey">
    <v-no-ssr>
      <vue-recaptcha
        size="normal"
        theme="light"
        :hl="locale"
        :loading-timeout="30000"
        @verify="emitVerify"
        @expire="onExperid"
        @error="onExperid"
        :sitekey="sitekey"
        ref="recaptcha"
      >
      </vue-recaptcha>
    </v-no-ssr>
  </template>
  <template v-else>
    <slot />
  </template>
</template>
